<template>
  <div v-if="totalCount > perPage" class="pagination-bar">
    <div class="d-flex align-items-center page-size-selector">
      <label class="mb-0 mr-2 text-muted small">{{ $t('generalMessages.show') }}</label>
      <d-select v-model.number="localPerPage" class="page-size-select">
        <option :value="10">10</option>
        <option :value="15">15</option>
        <option :value="20">20</option>
        <option :value="50">50</option>
        <option :value="100">100</option>
      </d-select>
    </div>
    <Pagination
      :totalPages="totalPages"
      :totalCount="totalCount"
      :perPage="perPage"
      :currentPage="currentPage"
      @pagechanged="(page) => $emit('pagechanged', page)"
    />
    <div class="page-size-spacer"></div>
  </div>
</template>

<script>
import Pagination from './Pagination.vue';

export default {
  name: 'PaginationBar',
  components: { Pagination },
  props: {
    totalPages: { type: Number, default: 0 },
    totalCount: { type: Number, default: 0 },
    perPage: { type: Number, required: true },
    currentPage: { type: Number, default: 1 },
  },
  computed: {
    localPerPage: {
      get() {
        return this.perPage;
      },
      set(val) {
        this.$emit('update:perPage', val);
      },
    },
  },
};
</script>

<style scoped>
.pagination-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
}

.page-size-selector {
  white-space: nowrap;
  min-width: 100px;
}

.page-size-spacer {
  min-width: 100px;
}

.page-size-select {
  width: 70px;
  height: 32px;
  padding: 2px 6px;
  font-size: 0.8125rem;
}
</style>
